import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'

/**
 * ProtectedRoute Component
 * Redirects to login if user is not authenticated
 */
export default function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  return children
}